import Vue from 'vue'
import Vuex from 'vuex'
import AuthService from '../services/authService'
import LoginService from '../services/requests/loginService'
import ProvedorAutenticacao from '../services/provedorAutenticacao'
import FrontendConfigService from '@/services/configs/frontendConfigService'

//import router from '../router/index'
Vue.use(Vuex)

const loginStore = new Vuex.Store({

	state: {
		isAuthenticated: AuthService.isAuthenticated(),
		userAuthenticated: AuthService.obterUsuarioAutenticado(),
		loading: false,
		authorization:null,
		
		notifications:[],
	},
	mutations: {
		setLoading(state, value){state.loading = value},
		setIsAuthenticated(state, value){state.isAuthenticated = value},
		iniciarSessao(state, {callback, login}){
			const provider = new ProvedorAutenticacao()
			const auth = provider.iniciarSessao(callback, login)
			state.isAuthenticated = auth.isAuthenticated
			state.userAuthenticated = auth.userAuthenticated
			state.authorization = auth.authorization
			//console.log('iniciar sessao',state)
		},
		encerrar(state){
			const provider = new ProvedorAutenticacao()
			const auth = provider.encerrarSessao()
			state.isAuthenticated = auth.isAuthenticated
			state.userAuthenticated = auth.userAuthenticated
			state.authorization = auth.authorization
			//console.log('encerrar sessao',state)
		},
		setNotifications(state, value){ 
			state.notifications = value 
		}
	},
	getters:{
		getUserAthenticated(state){
			return state.userAuthenticated
		},
		getIsLoading(state){
			return state.loading
		},
		getNotifications(state){
			return state.notifications
		},
	},
	actions:{
		tryError: async(context, error)=>{
			let err = FrontendConfigService.tryNotificationErrors(error)
			//console.log(err)
			context.commit('setNotifications', [{'tag':err.tag, 'message': err.message}])
		},
		acessar: async (context, {username, password}) =>{
			const login = new LoginService()
			context.commit('setLoading', true)
			return await login.jwt({ username, password})
			
		}
	}
})
export default loginStore
